import React, {
  useState,
  useEffect,
  ReactElement,
  CSSProperties,
  isValidElement,
  cloneElement,
} from 'react';
import DetailIcon from '@/common/detail-icon';
import './index.less';

export default function DetailDialog({
  children,
  iframeUrl,
  className,
  style,
  title,
}: {
  children: ReactElement;
  iframeUrl: string;
  title: string;
  className?: string;
  style?: CSSProperties;
}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // 组件卸载时恢复滚动
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isVisible]);

  const closeDialog = () => {
    setIsVisible(false);
  };

  return (
    <>
      {isValidElement(children) &&
        cloneElement(children, { onClick: () => setIsVisible(true) } as Partial<
          React.HTMLProps<HTMLElement>
        >)}

      {isVisible && (
        <div className="detail-dialog-overlay" onClick={closeDialog}>
          <div className={`detail-dialog-content ${className}`} style={style}>
            <iframe src={iframeUrl} title={title} />
            <div className="detail-dialog-common-close">
              <DetailIcon
                symbol={'icon-close-fill'}
                className="detail-dialog-common-close-icon"
                onClick={closeDialog}
                aria-label="Close dialog"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
